import React, { useState } from 'react';
import './PriceFilter.css';
import { AssetUrls } from 'config/assets';

interface PriceFilterProps {
  defaultMin?: number;
  defaultMax?: number;
  onChange?: (min: number, max: number) => void;
}

const formatNumber = (value: number) => value.toLocaleString('en-US');

const PriceFilter: React.FC<PriceFilterProps> = ({
  defaultMin = 4353,
  defaultMax = 54999,
  onChange,
}) => {
  const [minPrice, setMinPrice] = useState(defaultMin);
  const [maxPrice, setMaxPrice] = useState(defaultMax);

  const handleMinChange = (value: number) => {
    setMinPrice(value);
    onChange?.(value, maxPrice);
  };

  const handleMaxChange = (value: number) => {
    setMaxPrice(value);
    onChange?.(minPrice, value);
  };

  const parseInput = (e: React.ChangeEvent<HTMLInputElement>) =>
    Number(e.target.value.replace(/,/g, '')) || 0;

  const calculateWidth = (value: number) => {
    const digits = value.toString().length;
    return `${Math.max(5, digits + 1)}ch`; // minimum width of 5ch
  };

  return (
    <div className="price-filter">
      {/* MIN PRICE FIELD */}
      <div className="price-field">
        <label>Price (min.)</label>
        <div className="price-input-wrapper">
          <div className="price-arrows">
            <img
              src={AssetUrls.icons.dropdowns.arrowUp}
              alt="up"
              onClick={() => handleMinChange(minPrice + 1)}
            />
            <img
              src={AssetUrls.icons.dropdowns.arrowDown}
              alt="down"
              onClick={() => handleMinChange(Math.max(0, minPrice - 1))}
            />
          </div>
          <input
            type="text"
            style={{ width: calculateWidth(minPrice) }}
            value={formatNumber(minPrice)}
            onChange={(e) => handleMinChange(parseInput(e))}
          />
        </div>
      </div>

      {/* MAX PRICE FIELD */}
      <div className="price-field">
        <label>Price (max.)</label>
        <div className="price-input-wrapper">
          <div className="price-arrows">
            <img
              src={AssetUrls.icons.dropdowns.arrowUp}
              alt="up"
              onClick={() => handleMaxChange(maxPrice + 1)}
            />
            <img
              src={AssetUrls.icons.dropdowns.arrowDown}
              alt="down"
              onClick={() => handleMaxChange(Math.max(minPrice, maxPrice - 1))}
            />
          </div>
          <input
            type="text"
            style={{ width: calculateWidth(maxPrice) }}
            value={formatNumber(maxPrice)}
            onChange={(e) => handleMaxChange(parseInput(e))}
          />
        </div>
      </div>
    </div>
  );
};

export default PriceFilter;
